class CurrencyFormat {
  private static formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  static format(value: number): string {
    const formattedValue = this.formatter.format(value || 0);
    return formattedValue.replace(/,(\d{2})$/, ''); // Removes the decimal places
  }
  
  static formatMoneyWithDecimais(value: number): string {
    return this.formatter.format(value || 0).toLocaleString()
  }

  static formatWithDecimais(value: number): string {
    return (value || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  static formatNumber(value: number): string {
    return this.format(value).replace('R$', '').trim();
  }
}

export default CurrencyFormat;